import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9253da14"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tenant-user-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  class: "pagination-box"
};
import { onMounted, ref } from 'vue';
import { Search, Refresh } from '@element-plus/icons-vue';
import usePagination from '@/hooks/usePagination';
import { indexMethod } from '@/utils/indexMethod';
import { getApplinkLogList } from '@/api/sys';
import dayjs from 'dayjs';
export default {
  __name: 'index',
  setup(__props) {
    const {
      currentPage,
      total,
      pageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const tableData = ref([]);
    const loading = ref(false);
    const keyword = ref('');
    const date = ref([dayjs(), dayjs()]);
    const _getApplinkLogList = async () => {
      loading.value = true;
      const res = await getApplinkLogList({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        clinicName: keyword.value,
        createTimeMin: date.value[0] ? dayjs(date.value[0]).format('YYYY-MM-DD') : '',
        createTimeMax: date.value[0] ? dayjs(date.value[1]).format('YYYY-MM-DD') : ''
      });
      tableData.value = res.records;
      setTotal(res.total);
      loading.value = false;
    };
    onMounted(() => {
      _getApplinkLogList();
    });
    const handleCurrentChange = e => {
      setCurrentPage(e);
      _getApplinkLogList();
    };
    const handleRefresh = async () => {
      setCurrentPage(1);
      keyword.value = '';
      date.value = [dayjs(), dayjs()];
      _getApplinkLogList();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "header",
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "门店名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "300px"
              },
              placeholder: "请输入门店名称",
              modelValue: keyword.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "时间段"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: date.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => date.value = $event),
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: _unref(Search),
              onClick: _getApplinkLogList
            }, {
              default: _withCtx(() => [_createTextVNode(" 查询 ")]),
              _: 1
            }, 8, ["icon"]), _createVNode(_component_el_button, {
              icon: _unref(Refresh),
              onClick: handleRefresh
            }, {
              default: _withCtx(() => [_createTextVNode(" 重置 ")]),
              _: 1
            }, 8, ["icon"])]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: true,
          data: tableData.value,
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "#",
            type: "index",
            index: index => _unref(indexMethod)(index, _unref(currentPage), _unref(pageSize)),
            "min-width": "20"
          }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
            label: "门诊",
            prop: "clinicName"
          }), _createVNode(_component_el_table_column, {
            label: "ip",
            prop: "ip"
          }), _createVNode(_component_el_table_column, {
            label: "每次请求时间(毫秒)",
            prop: "useTime"
          }), _createVNode(_component_el_table_column, {
            label: "请求时间",
            prop: "createTime"
          }), _createVNode(_component_el_table_column, {
            label: "请求服务状态",
            prop: "status"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("div", {
              style: _normalizeStyle({
                color: row.status === 0 ? 'green' : 'red'
              })
            }, _toDisplayString(row.status === 0 ? '成功' : '失败'), 5)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total, prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      })]);
    };
  }
};